<template>
    <component :is="layout">
        <h1 class="heading">{{ methodName }}</h1>
        <form class="add-task-form" @submit.prevent="sendForm">
            <task-parameters :fields="method.methodFields"
                             :method-is-locked="methodIsDisabled"
                             :server-validation-messages="validationErrors"
                             ref="params" />

            <div class="field-group">
                <h3 class="field-group-heading strong">Формат выходного файла*</h3>
                <v-select
                    :options="outputFormatsAsOptions"
                    v-model="form.out_type"
                    required="" />
            </div>

            <div class="field-group">
                <h3 class="field-group-heading strong">Название задачи*</h3>
                <text-input
                    input-id="task-name"
                    placeholder="Название задачи"
                    v-model="form.name"
                    :readonly="methodIsDisabled"
                    required="" />
            </div>
            <v-button
                :type="methodIsDisabled ? 'button': 'submit'"
                v-tooltip.right='toolTipButtonMessage'
                :disabled="methodIsDisabled"
                label="Запустить"/>
        </form>
        <template v-slot:help-block>
            <h3>{{ methodName }}</h3>
            <div v-html="method.help"></div>
        </template>
    </component>
</template>

<script>
  import { MethodsAPI } from 'api-client'
  import { TasksAPI } from 'api-client'
  import vButton from '../components/vButton'
  import TextInput from '../components/form_components/TextInput'
  import AutoField from '../components/form_components/AutoField'
  import vSelect from '../components/form_components/vSelect'
  import InputTip from "../components/form_components/InputTip";
  import TaskParameters from "../components/TaskParameters";

  export default {
    name: 'AddTask',
    components: {
      InputTip,
      vButton,
      AutoField,
      TextInput,
      vSelect,
      TaskParameters
    },
    props: {
      embedded: {
        type: Boolean,
        default: false,
      },
      methodInfo: {
        type: Object,
        default: undefined,
      }
    },
    data() {
      return {
        layout: this.embedded ? 'simple-layout' : 'default-layout',
        method: {
          methodFields: [],
        },
        form: {
          method: -1,
          name: '',
          out_type: '',
        },
        validationErrors: {},
      }
    },
    computed: {
      outputFormatsAsOptions() {
        const formats = this.method.outputTypes || []
        return formats.map(type => { return { key: type, value: type } })
      },
      methodName() {
        return this.method.name
      },
      methodIsDisabled() {
        return this.method.locked
      },
      userRole(){
        return this.$store.state.session.role;
      },
      toolTipButtonMessage() {
        const message = `У вас не хвататет привелегий для запуска данного метода.
        Ваш уровень профиля "${this.userRole}"`;
        return this.methodIsDisabled ? message : ""
      }
    },
    methods: {
      async sendForm() {
        this.clearErrors()

        const formToSend = Object.assign({}, this.form);
        this.putArgsToForm(formToSend, this.$refs.params.preparedToSend);

        try {
          await TasksAPI.addTask(formToSend);
          this.$router.push('/');
        } catch (error) {
          window.console.log(error);
          this.handleError(error);
        }
      },

      // In most cases, args are just jsonified and put in form
      // with key 'args'.
      //
      // Specific thing is in handling file arguments. They're put
      // in form directly omitting 'args'.
      putArgsToForm(form, args) {
        for (const key in args) {
          if (args[key] instanceof File) {
            form[key] = args[key]
            delete args[key]
          }
        }

        form['args'] = JSON.stringify(args);
      },

      handleError(error) {
        if (error.validationErrors) {
          for (const fieldError of error.validationErrors) {
            this.$set(this.validationErrors, fieldError.fieldKey, fieldError.errorMsg)
          }
          alert('Ошибка в заполнении формы')
        } else {
          alert('Ошибка создания задачи')
        }
      },

      clearErrors() {
        this.validationErrors = {}
      },

      // TODO: what is it for?
      updateDynamicRoutesInStore() {
        const routes = {
          methods: {
            params: {
              platform: this.method.platform.code
            }
          },
          'addTask': {
            title: this.methodName
          }
        };

        this.$store.commit('setBreadcrumbsDynamicRoutes', routes)
      },

      getCurrentDate() {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();
        return  mm + '/' + dd + '/' + yyyy;
      }
    },

    async created() {
      if (this.methodInfo === undefined) {
        this.form.method = this.$route.params.id
        this.method = await MethodsAPI.methodInfo(this.form.method)
      } else {
        this.method = this.methodInfo
        this.form.method = this.method.id
      }
      this.form.name = this.method.name + " " + this.getCurrentDate()
      this.form.out_type = this.method.outputTypes ? this.method.outputTypes[0] : ''
      this.updateDynamicRoutesInStore()
    },
  }
</script>

<style lang="sass">
    .field-group-heading
        margin-top: 0
        margin-bottom: gridSteps(2)

        .field-group
            margin-bottom: gridSteps(3)
</style>
